import React from 'react';
import { Switch, Text } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

/**
 * Champ visibilité partagé (Section/Titre/Texte) : switch « œil » en tête de
 * rightbar. Donnée inchangée : isVisible boolean.
 */
function VisibilitySwitch({ value, onChange }) {
  const visible = value !== false;
  return (
    <div>
      <Switch
        size="sm"
        checked={visible}
        onChange={(e) => onChange(e.currentTarget.checked)}
        label="Visible sur le site"
        thumbIcon={visible
          ? <FontAwesomeIcon icon={icon({ name: 'eye', style: 'solid' })} style={{ fontSize: 12 }} />
          : <FontAwesomeIcon icon={icon({ name: 'eye-slash', style: 'solid' })} style={{ fontSize: 12 }} />}
      />
      {!visible && (
        <Text size="xs" c="dimmed" mt={4}>
          Le bloc reste ici mais n'apparaît pas sur le site publié.
        </Text>
      )}
    </div>
  );
}

export function puckVisibilityField() {
  return {
    type: 'custom',
    label: 'Visible sur le site',
    render: ({ value, onChange }) => (
      <VisibilitySwitch value={value} onChange={onChange} />
    ),
  };
}
